import FileViewer from 'container/components/Common/FileViewer';

const Resume = ({ resumeObj }) => {
  return <FileViewer bucketKey={resumeObj.bucket_key} />;
};

export default Resume;
